var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeTraffic01 = function SvgTypeTraffic01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "type_traffic-01_svg2__a",
    x1: 29.83,
    x2: 175.9,
    y1: 169.84,
    y2: 61.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_traffic-01_svg2__a",
    id: "type_traffic-01_svg2__b",
    x1: 44.56,
    x2: 190.63,
    y1: 189.62,
    y2: 80.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_traffic-01_svg2__a",
    id: "type_traffic-01_svg2__c",
    x1: 49.38,
    x2: 195.45,
    y1: 196.09,
    y2: 87.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_traffic-01_svg2__a",
    id: "type_traffic-01_svg2__d",
    x1: 57.63,
    x2: 203.7,
    y1: 207.17,
    y2: 98.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_traffic-01_svg2__a",
    id: "type_traffic-01_svg2__e",
    x1: 47.32,
    x2: 193.39,
    y1: 193.33,
    y2: 84.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_traffic-01_svg2__a",
    id: "type_traffic-01_svg2__f",
    x1: -4.51,
    x2: 141.56,
    y1: 123.73,
    y2: 14.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_traffic-01_svg2__a",
    id: "type_traffic-01_svg2__g",
    x1: -7.02,
    x2: 139.05,
    y1: 120.37,
    y2: 11.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_traffic-01_svg2__a",
    id: "type_traffic-01_svg2__h",
    x1: 4.82,
    x2: 150.89,
    y1: 136.26,
    y2: 27.46
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.38 129.18a20.6 20.6 0 0 0-6.19-13.05c-2-2.13-4.75-5.04-11.77-5.04a8.62 8.62 0 0 0-7.16 3.51c-2.63 3.57-2.41 8.7-1.62 11.28.37 1.2 1.14 3.7 10.67 6.43 1.64.47 6.61 1.79 10.24 1.79 3.51.17 6.11-2 5.83-4.91Zm-19.7-6.24c-.16-1.23 0-3.01.63-3.89.14-.19.33-.45 1.12-.45 3.78 0 4.67.95 6.3 2.68a14.2 14.2 0 0 1 3.4 5.1c-3.72-.6-9.45-2.25-11.45-3.44",
    style: {
      fill: "url(#type_traffic-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 121.59H109.5c-4.96.17-4.98 7.34 0 7.51h42.73c4.96-.17 4.98-7.34 0-7.51",
    style: {
      fill: "url(#type_traffic-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.21 131.64h-32.68c-4.96.17-4.98 7.34 0 7.51h32.68c4.96-.17 4.98-7.34 0-7.51",
    style: {
      fill: "url(#type_traffic-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.31 111.09c-7.01 0-9.77 2.91-11.77 5.04a20.57 20.57 0 0 0-6.18 13.05c-.17 1.95 1 4.18 3.94 4.76 3.67.68 10.15-1.09 12.12-1.64 9.52-2.72 10.3-5.22 10.67-6.43 1.73-5.64-.46-14.81-8.78-14.78m1.74 11.85c-2 1.19-7.72 2.85-11.45 3.44.74-1.93 1.9-3.67 3.4-5.1 1.63-1.73 2.5-2.68 6.3-2.68.79 0 1 .26 1.12.45.63.87.79 2.66.63 3.89",
    style: {
      fill: "url(#type_traffic-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.32 91c-3.39 0-6.01 1.37-7.51 3.77l-8.52-17.7c-2.12-4.42-7.57-5.85-9.19-6.18-8.22-1.69-16.53-1.87-32.25-1.87s-24.04.19-32.24 1.87c-1.62.34-7.07 1.76-9.19 6.18l-8.51 17.7C79.41 92.37 76.8 91 73.4 91c-16.82.54-14.65 17.97 1.48 16.87a51 51 0 0 1-5.14 8.17 16.05 16.05 0 0 0-3.25 12.48c1.5 9.05 1.66 17.7 1.68 25.09 0 1.64.51 3.25 1.44 4.6v10.35c0 4.01 3.24 7.27 7.26 7.28H88.3c4.01 0 7.26-3.26 7.25-7.27v-6.8h70.62v6.8c0 4.01 3.25 7.25 7.26 7.26h11.44c4.01 0 7.25-3.25 7.26-7.26v-10.35a8.1 8.1 0 0 0 1.44-4.59c.03-7.95.25-16.49 1.68-25.1.71-4.43-.47-8.96-3.25-12.48a51 51 0 0 1-5.14-8.17c16.15 1.09 18.31-16.34 1.46-16.87ZM96.21 80.33c3.22-4.13 21.89-3.65 34.66-3.8 12.79.16 31.41-.34 34.67 3.8l8.01 16.61H88.21l7.99-16.61ZM73.4 100.39c-1.34.05-2.67-.28-3.83-.94 1.17-.67 2.5-1 3.85-.94.17 0 1 0 1.16.27.23.48.34 1.01.32 1.55-.5.05-1 .07-1.5.07Zm14.64 67.94H77.13v-6.56h10.91zm6.57-14.07c2.1-2.27 3.51-3.45 5.71-3.45h61.11c2.19 0 3.61 1.18 5.71 3.45zm90 14.07H173.7v-6.56h10.91zm3.23-41.03c-1.5 9.13-1.75 18.03-1.78 26.3 0 .37-.3.66-.67.66h-7.68c-5.29-4.26-7.81-10.83-16.28-10.96h-61.11c-8.47.14-10.98 6.7-16.28 10.96h-7.65a.67.67 0 0 1-.67-.67c-.03-8.25-.27-17.15-1.78-26.3-.37-2.35.26-4.74 1.74-6.61 3.22-4.13 6.22-9.45 9.09-16.22h92.24c2.87 6.75 5.86 12.08 9.1 16.21a8.49 8.49 0 0 1 1.75 6.62Zm-1.01-26.97c-.02-.53.09-1.07.32-1.55.18-.26 1-.27 1.16-.27 1.35-.05 2.68.27 3.85.94-1.17.67-2.5 1-3.85.95h.02c-.5 0-1-.02-1.5-.07",
    style: {
      fill: "url(#type_traffic-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.58 119.89h20.54c2.07 0 3.76-1.68 3.76-3.76s-1.68-3.76-3.76-3.76H38.58c-8.47.14-10.98 6.7-16.28 10.96h-7.68a.67.67 0 0 1-.67-.67c-.03-8.25-.27-17.15-1.78-26.3-.37-2.35.26-4.75 1.74-6.61 3.25-4.13 6.24-9.46 9.11-16.21h61.41c2.07 0 3.76-1.68 3.76-3.76s-1.68-3.76-3.76-3.76H26.47l8.01-16.63c3.23-4.12 21.88-3.65 34.67-3.79 12.79.15 31.4-.34 34.66 3.79l5.35 11.14c.9 1.87 3.14 2.66 5.01 1.76s2.66-3.14 1.76-5.01l-5.35-11.14c-2.12-4.41-7.57-5.85-9.19-6.18-8.22-1.69-16.53-1.87-32.24-1.87s-24.04.19-32.25 1.87c-1.62.33-7.07 1.76-9.19 6.18l-8.52 17.7c-1.5-2.4-4.12-3.78-7.51-3.78C-5.17 60.6-3 78.04 13.14 76.94A50.5 50.5 0 0 1 8 85.1a16.05 16.05 0 0 0-3.25 12.48c1.5 9.05 1.66 17.7 1.68 25.09 0 1.64.51 3.25 1.44 4.6v10.37a7.25 7.25 0 0 0 7.26 7.25h11.42c4 0 7.25-3.25 7.25-7.25v-6.82h25.3c2.07 0 3.76-1.68 3.76-3.76s-1.68-3.76-3.76-3.76H32.87c2.1-2.27 3.51-3.45 5.71-3.45ZM11.66 69.47c-1.34.05-2.67-.28-3.83-.94 1.17-.67 2.51-.99 3.85-.94.17 0 1 0 1.16.27.23.48.34 1.02.32 1.55q-.75.075-1.5.06m14.63 67.94h-10.9v-6.56h10.9z",
    style: {
      fill: "url(#type_traffic-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.69 80.17c-8.31-.03-10.52 9.14-8.78 14.78.37 1.2 1.14 3.7 10.67 6.43 1.97.55 8.45 2.32 12.12 1.64 2.96-.58 4.11-2.81 3.94-4.76-.39-4.75-2.43-9.22-5.78-12.62-2.42-2.5-4.72-5.38-12.18-5.46Zm-1.75 11.85c-.16-1.24 0-3.01.63-3.89.14-.19.33-.45 1.12-.45 3.78 0 4.67.95 6.3 2.67 1.49 1.42 2.65 3.16 3.4 5.08-3.72-.58-9.45-2.23-11.45-3.42Z",
    style: {
      fill: "url(#type_traffic-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.68 33.7a277 277 0 0 1 30.99-2.04c15.71 0 23.44.28 30.63 1.97 1.55.37 3.44 1.32 3.96 2.54l10.58 25.37c.77 1.93 2.96 2.86 4.88 2.09s2.86-2.96 2.09-4.88c-.01-.03-.03-.07-.04-.1l-10.58-25.37c-2.07-4.96-7.54-6.59-9.19-6.96-7.92-1.87-16.03-2.17-32.35-2.17a278 278 0 0 0-31.98 2.1c-2.06.28-3.5 2.17-3.22 4.22s2.17 3.5 4.23 3.22Z",
    style: {
      fill: "url(#type_traffic-01_svg2__h)"
    }
  }));
};
export default SvgTypeTraffic01;